import { render, staticRenderFns } from "./DocumentsStatements.vue?vue&type=template&id=1127e0a0&scoped=true"
import script from "./DocumentsStatements.vue?vue&type=script&lang=js"
export * from "./DocumentsStatements.vue?vue&type=script&lang=js"
import style0 from "./DocumentsStatements.vue?vue&type=style&index=0&id=1127e0a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127e0a0",
  null
  
)

export default component.exports